import React from 'react';
import { CircularProgress, Box, Typography, Backdrop } from '@mui/material';
import { RiseLoader } from 'react-spinners';

const Loader = ({ loading, message }) => {
    return (
        <Backdrop
            open={loading}
            sx={{
                zIndex: (theme) => theme.zIndex.modal + 1,
                color: '#fff',
                flexDirection: 'column',
            }}
        >
            {/* <RiseLoader loading={loading} color='#F49507' size={24} /> */}
            <CircularProgress color="inherit" />
            {message && (
                <Typography variant="h6" sx={{ mt: 2 }}>
                    {message}
                </Typography>
            )}
        </Backdrop>
    );
};

export default Loader;
